import Vue from 'vue';
import Buefy from 'buefy';
import BuefyCustomSvgIcon from '@/components/atoms/icons/BuefyCustomSvgIcon.vue';
import './custom.scss';

Vue.use(Buefy, {
  defaultIconPack: null,
  defaultIconComponent: BuefyCustomSvgIcon,
});
